import styles from "./styles.module.scss";
import { Header } from "./header";
import { Hero } from "./hero";
import { Features } from "./features";
import { Brands } from "./brands";
import { Transform } from "./transform";
import { Reviews } from "./reviews";
import { FAQSection } from "./faq";
import { Footer } from "./footer";
import { Results } from "./results";
import { WORKFLOW } from "src/appConfig";

export const LandingPage = () => {
  const isWalky = WORKFLOW === "WALKY";

  return (
    <div className={styles.container}>
      <Header isWalky={isWalky}/>
      <Hero isWalky={isWalky}/>
      <Brands />
      <Transform isWalky={isWalky} />
      <Features isWalky={isWalky}/>
      <Results isWalky={isWalky}/>
      <Reviews isWalky={isWalky} />
      <FAQSection isWalky={isWalky}/>
      <Footer isWalky={isWalky}/>
    </div>
  );
};
